<div class="page-content-1">
    <ng-sidebar-container style="height: 100%;">
        <ng-sidebar mode="over" [keyClose]="false" position="right" [dock]="false" [dockedSize]="'50px'"
            [autoCollapseHeight]="500" [autoCollapseWidth]="500" [closeOnClickOutside]="false"
            [closeOnClickBackdrop]="false" [showBackdrop]="true" [animate]="true" [trapFocus]="false" [autoFocus]="true"
            [ariaLabel]="'Menu'">
            <!-- <app-filter-report (closeSideForm)="_toggleOpened()"></app-filter-report> -->
        </ng-sidebar>
        <div ng-sidebar-content class="sidebar-content">
            <!-- Search Div -->
            <div class="row mb-3 align-items-center justify-content-start" style="width: 100%;">
                <div class="col-md-10">
                    <div class="search-box">
                        <input class="search-input" type="text" name="searchQuery" id="searchQuery"
                            [(ngModel)]="searchQuery" (input)="serachWebhookLog()"
                            placeholder="Search by name & status...">
                        <div class="search-button display-flex align-items-center" (click)="serachWebhookLog()">
                            <img src="../../../../assets/img/ic_Search.svg" class="mr-2" style="height: 20px;"
                                alt=""><span style="font-size: 15px;">Search</span>
                        </div>
                    </div>
                </div>

            </div>

            <!-- Table -->
            <div *ngIf="isLoading" class="display-flex align-items-center" style="height: 60vh;">
                <mat-progress-spinner mode="indeterminate" diameter="40" style="margin:0 auto;">
                </mat-progress-spinner>
            </div>
            <div *ngIf="!isLoading && listOfResult.length<=0"
                class="display-flex align-items-center justify-content-center" style="height: 60vh;">
                No data available
            </div>
            <div *ngIf="!isLoading && listOfResult.length>0">
                <table cellspacing="0" cellpadding="0" style="width: 100%;padding-right: 10px;">
                    <tr class="table-heading tr-style">
                        <th class="th-weight">
                            Email</th>
                        <th class="th-weight">
                            Mobile Number</th>
                        <th class="th-weight">
                            Date</th>

                    </tr>
                    <tbody *ngIf=" listOfResult.length>0">
                        <tr class="table-data" *ngFor="let data of listOfResult ">
                            <th class="table-data-content">{{data['log']['payload']['payment']['entity']['email']}}
                            </th>
                            <th class="table-data-content">{{data['log']['payload']['payment']['entity']['contact']}}
                            </th>
                            <th class="table-data-content">{{getDate(data['log']['payload']['payment']['entity']['created_at']) | date}}
                            </th>





                        </tr>
                    </tbody>
                </table>

            </div>

            <div style="height: 10em;">

            </div>
        </div>
    </ng-sidebar-container>
</div>